import { render, staticRenderFns } from "./postTelegram.vue?vue&type=template&id=8741650a&"
import script from "./postTelegram.vue?vue&type=script&lang=js&"
export * from "./postTelegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports